import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconImageAltText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"image-alt-text"} maskId="square-filled-radius-0-stroke-1-IconImageAltText"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM4 4V10.697L7.9809 6.2738L15.7071 14H20V4H4ZM20 15H4V20H20V15ZM14 8C14 6.89543 14.8954 6 16 6C17.1046 6 18 6.89543 18 8C18 9.10457 17.1046 10 16 10C14.8954 10 14 9.10457 14 8ZM6 17H12V18H6V17ZM14 17H18V18H14V17Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconImageAltText;
